module.exports = __webpack_public_path__ + "static/media/all.d88b2608.pred";